import { render, staticRenderFns } from "./event_bar.vue?vue&type=template&id=6f89763a"
import script from "./event_bar.vue?vue&type=script&lang=js"
export * from "./event_bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports